import React from "react";
import PropTypes from "prop-types";
const Button = ({ btnClass, value, onClick, type, disabled, fa_icon, hidden, name }) => (
  <button
    className={`btn library-btn ${btnClass}`}
    onClick={(event) => onClick(event)}
    type={type?type:"button"}
    disabled={disabled}
    hidden={hidden}
    name={name}
  >
    <i className={fa_icon}></i>
    &nbsp;{value}
  </button>
);

Button.propTypes = {
  btnClass: PropTypes.string,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hidden:PropTypes.bool,

};

Button.defaultProps = {
  btnClass: "btn-primary",
  disabled:false,
  hidden:false
};
export default Button;
